module.exports = __webpack_public_path__ + "img/7.f03c6f3e.jpg";